<template>
  <div>
    <div class="d-flex align-center mb-4 h-35px px-1">
      <b-button-group class="ml-auto" size="sm">
        <button
          @click="addRule"
          :class="currentQuery.length >= parseInt(length) ? 'disabled' : ''"
          :disabled="currentQuery.length >= parseInt(length)"
          class="btn btn-outline-info"
        >
          <b-icon-plus-circle /> Add box
        </button>
      </b-button-group>
    </div>
    <template v-if="currentQuery.length === 0">
      <div class="text-center text-muted poppins-ls pb-8">No data</div>
    </template>
    <template v-else>
      <template v-for="(item, index) in currentQuery">
        <Action :rule="item" :key="index" class="mt-2 px-1" ref="action" />
      </template>
    </template>
  </div>
</template>

<script>
import Action from "@/own/components/fulfillment/returned/actionBuilder/Action.vue";
export default {
  name: "ActionGroup",
  components: { Action },
  props: {
    currentQuery: {
      type: Array,
      required: true,
    },
    length: {
      type: Number,
      required: true,
    },
  },
  mounted: function () {
    // this.$nextTick(() => {
    //   if (this.currentQuery.length === 0) {
    //     this.addRule();
    //   }
    // });
  },
  // computed: {
  //   selectedStatusId: function () {
  //     // Status ID is 6
  //     return this.currentQuery.find((option) => option.id === 6)?.value;
  //   },
  // },
  methods: {
    addRule() {
      const newGroup = {
        number: "box" + (this.currentQuery.length + 1),
        width: null,
        height: null,
        depth: null,
        weight: null,
      };
      this.currentQuery.push(newGroup);
    },
  },
  // watch: {
  //   currentQuery: {
  //     handler() {
  //       // Status ID is 6 return_status
  //     },
  //     deep: true,
  //   },
  // },
};
</script>
